import { render } from "./TestArchive.vue?vue&type=template&id=29fe8c8d"
import script from "./TestArchive.vue?vue&type=script&lang=js"
export * from "./TestArchive.vue?vue&type=script&lang=js"
script.render = render

export default script